import React, { Dispatch, SetStateAction } from "react";

import Button from "../../../atoms/ActiveLearning/Button";

import styles from "./ToggleMaterialAndAnswerButton.module.scss";

type ToggleMaterialAndAnswerButtonProps = {
  contents: string;
  setViewContentType: Dispatch<SetStateAction<"material" | "answer">>;
};

export const ToggleMaterialAndAnswerButton: React.FC<ToggleMaterialAndAnswerButtonProps> = ({
  contents,
  setViewContentType,
}) => {
  return (
    <div className={styles.wrapper}>
      <Button
        variant={contents === "material" ? "primary" : "secondaryBgWhite"}
        width={"240px"}
        height={"40px"}
        fontSize={"14px"}
        handleClick={() => setViewContentType("material")}
      >
        教材
      </Button>
      <Button
        variant={contents === "answer" ? "primary" : "secondaryBgWhite"}
        width={"240px"}
        height={"40px"}
        fontSize={"14px"}
        handleClick={() => setViewContentType("answer")}
      >
        回答
      </Button>
    </div>
  );
};

export default ToggleMaterialAndAnswerButton;
